"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFeatureStateFromICResult = exports.getFeatureStateFromICPromise = exports.getFeatureStateFromSettledPromiseResult = exports.getDataProviderCommonStateFromICResult = exports.getDataProviderCommonStateFromICPromise = exports.getDataProviderCommonStateFromSettledPromiseResult = exports.getDataProviderStateErrorFromCommonState = exports.simpleFeatureReducer = exports.initialDataProviderCommonState = exports.initialDataProviderState = exports.getInitialDataProviderStateError = exports.getInitialDataProviderStateStatus = void 0;
const ICCanisterUtils_1 = require("src/hello_assets/src/util/ICCanisterUtils");
const lodash_1 = __importDefault(require("lodash"));
const getInitialDataProviderStateStatus = () => lodash_1.default.cloneDeep({ loaded: false, inProgress: false });
exports.getInitialDataProviderStateStatus = getInitialDataProviderStateStatus;
const getInitialDataProviderStateError = () => lodash_1.default.cloneDeep({ isError: false, error: undefined });
exports.getInitialDataProviderStateError = getInitialDataProviderStateError;
exports.initialDataProviderState = {
    status: (0, exports.getInitialDataProviderStateStatus)(),
    error: (0, exports.getInitialDataProviderStateError)(),
    data: undefined
};
exports.initialDataProviderCommonState = {
    loaded: false,
    inProgress: false,
    error: undefined,
    isError: false,
    data: undefined
};
function simpleFeatureReducer(state, newState) {
    const result = { ...state };
    lodash_1.default.each(newState, (value, key) => {
        if (value === undefined) {
            result[key] = undefined;
        }
        else {
            result[key] = {
                ...result[key],
                ...value
            };
        }
    });
    return result;
}
exports.simpleFeatureReducer = simpleFeatureReducer;
const getDataProviderStateErrorFromCommonState = (state) => {
    if (state) {
        return {
            isError: state.isError,
            error: state.error
        };
    }
    return (0, exports.getInitialDataProviderStateError)();
};
exports.getDataProviderStateErrorFromCommonState = getDataProviderStateErrorFromCommonState;
const getDataProviderCommonStateFromSettledPromiseResult = (promiseSettledResult) => {
    let dataProviderCommonState;
    switch (promiseSettledResult.status) {
        case "fulfilled": {
            const promiseResult = promiseSettledResult.value;
            dataProviderCommonState = (0, exports.getDataProviderCommonStateFromICResult)(promiseResult);
            break;
        }
        case "rejected": {
            const reason = promiseSettledResult.reason;
            let error;
            if (reason instanceof Error) {
                error = reason;
            }
            else {
                error = new Error(`${reason}`);
            }
            dataProviderCommonState = {
                loaded: true,
                inProgress: false,
                error: error,
                isError: true,
                data: undefined
            };
            break;
        }
    }
    return dataProviderCommonState;
};
exports.getDataProviderCommonStateFromSettledPromiseResult = getDataProviderCommonStateFromSettledPromiseResult;
const getDataProviderCommonStateFromICPromise = async (promise) => {
    try {
        return (0, exports.getDataProviderCommonStateFromICResult)(await promise);
    }
    catch (error) {
        console.log("error", error);
        return {
            loaded: true,
            inProgress: false,
            isError: true,
            error: error,
            data: undefined
        };
    }
};
exports.getDataProviderCommonStateFromICPromise = getDataProviderCommonStateFromICPromise;
const getDataProviderCommonStateFromICResult = (promiseResult) => {
    let dataProviderCommonState;
    if ((0, ICCanisterUtils_1.isICRequestOk)(promiseResult)) {
        dataProviderCommonState = {
            loaded: true,
            inProgress: false,
            error: undefined,
            isError: false,
            data: promiseResult.ok
        };
    }
    else if ((0, ICCanisterUtils_1.isICRequestErr)(promiseResult)) {
        dataProviderCommonState = {
            loaded: true,
            inProgress: false,
            error: new Error((0, ICCanisterUtils_1.getICRequestErrName)(promiseResult)),
            isError: true,
            data: undefined
        };
    }
    else {
        console.log("return unknown error from getDataProviderCommonStateFromICResult");
        dataProviderCommonState = {
            loaded: true,
            inProgress: false,
            error: new Error("unknown"),
            isError: true,
            data: undefined
        };
    }
    return dataProviderCommonState;
};
exports.getDataProviderCommonStateFromICResult = getDataProviderCommonStateFromICResult;
const getFeatureStateFromSettledPromiseResult = (promiseSettledResult) => {
    let featuredState;
    if (promiseSettledResult) {
        switch (promiseSettledResult.status) {
            case "fulfilled": {
                const promiseResult = promiseSettledResult.value;
                featuredState = (0, exports.getFeatureStateFromICResult)(promiseResult);
                break;
            }
            case "rejected": {
                const reason = promiseSettledResult.reason;
                let error;
                if (reason instanceof Error) {
                    error = reason;
                }
                else {
                    error = new Error(`${reason}`);
                }
                featuredState = {
                    state: undefined,
                    isError: true,
                    error: error
                };
                break;
            }
        }
    }
    else {
        featuredState = {
            state: undefined,
            isError: true,
            error: new Error("unknown")
        };
    }
    return featuredState;
};
exports.getFeatureStateFromSettledPromiseResult = getFeatureStateFromSettledPromiseResult;
const getFeatureStateFromICPromise = async (promise) => {
    try {
        return (0, exports.getFeatureStateFromICResult)(await promise);
    }
    catch (error) {
        console.log("error", error);
        return {
            state: undefined,
            isError: true,
            error: error
        };
    }
};
exports.getFeatureStateFromICPromise = getFeatureStateFromICPromise;
const getFeatureStateFromICResult = (promiseResult) => {
    let featuredState;
    if ((0, ICCanisterUtils_1.isICRequestOk)(promiseResult)) {
        featuredState = {
            state: promiseResult.ok,
            isError: false,
            error: undefined
        };
    }
    else if ((0, ICCanisterUtils_1.isICRequestErr)(promiseResult)) {
        featuredState = {
            state: undefined,
            isError: true,
            error: new Error((0, ICCanisterUtils_1.getICRequestErrName)(promiseResult))
        };
    }
    else {
        featuredState = {
            state: undefined,
            isError: true,
            error: new Error("unknown")
        };
    }
    return featuredState;
};
exports.getFeatureStateFromICResult = getFeatureStateFromICResult;
